var NMIResource = function() {
  var self = this;
  
  self.submit = function(action, data) {
    // Build and submit the form
    var form = $('<form/>');
    form.attr('action', action);
    form.attr('method', 'POST');

    // card info
    var numberInput = $('<input type="hidden" name="billing-cc-number"/>');
    numberInput.attr('value', data.cardNumber);
    form.append(numberInput);

    var expiryInput = $('<input type="hidden" name="billing-cc-exp"/>');
    var yr = data.cardYear;
    if(yr.length === 4) yr = yr.substr(2);
    expiryInput.attr('value', data.cardMonth + yr);
    form.append(expiryInput);

    var cvvInput = $('<input type="hidden" name="billing-cvv"/>');
    cvvInput.attr('value', data.cardCode);
    form.append(cvvInput);

    var firstNameInput = $('<input type="hidden" name="billing-first-name"/>');
    firstNameInput.attr('value', data.firstName);
    form.append(firstNameInput);

    var lastNameInput = $('<input type="hidden" name="billing-last-name"/>');
    lastNameInput.attr('value', data.lastName);
    form.append(lastNameInput);

    // billing info
    var address1Input = $('<input type="hidden" name="billing-address1"/>');
    address1Input.attr('value', data.address1);
    form.append(address1Input);

    var address2Input = $('<input type="hidden" name="billing-address2"/>');
    address2Input.attr('value', data.address2);
    form.append(address2Input);

    var cityInput = $('<input type="hidden" name="billing-city"/>');
    cityInput.attr('value', data.city);
    form.append(cityInput);

    var stateInput = $('<input type="hidden" name="billing-state"/>');
    stateInput.attr('value', data.state);
    form.append(stateInput);
    
    var zipInput = $('<input type="hidden" name="billing-postal"/>');
    zipInput.attr('value', data.zip);
    form.append(zipInput);
    
    var countryInput = $('<input type="hidden" name="billing-country"/>');
    countryInput.attr('value', data.country);
    form.append(countryInput);

    var phoneInput = $('<input type="hidden" name="billing-phone"/>');
    phoneInput.attr('value', data.phone);
    form.append(phoneInput);


    form.appendTo('body');
    form.submit();
  };
};

window.nmiResource = new NMIResource();